import { useNavigate } from "react-router-dom";
import { Button } from "@/ui";
import { useT } from "@/app";
import { token } from "@/design/theme";

/**
 * Troubleshooting — a short, ordered checklist for a silent analyzer link (test → physical →
 * direction/mode → quarantine). Rendered in the device drawer and on the monitor; text-only guidance
 * so it works offline and reads under AT (ordered list). Each step is number + title + text.
 */
const STEPS = ["step1", "step2", "step3", "step4"] as const;

export function Troubleshooting() {
  const { t } = useT();
  const navigate = useNavigate();
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: token.s3 }}>
      <p style={{ margin: 0, color: token.slate }}>{t("lis.trouble.subtitle")}</p>
      <ol style={{ listStyle: "none", margin: 0, padding: 0, display: "flex", flexDirection: "column", gap: token.s2 }}>
        {STEPS.map((s, i) => (
          <li
            key={s}
            style={{
              display: "flex",
              gap: token.s3,
              padding: token.s3,
              border: `1px solid ${token.lineSoft}`,
              borderRadius: token.rMd,
              background: token.white,
            }}
          >
            <span
              aria-hidden
              className="nv-mono nv-ltr-island"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                inlineSize: 24,
                blockSize: 24,
                flex: "0 0 auto",
                borderRadius: token.rPill,
                background: token.azureSoft,
                color: token.azure600,
                fontWeight: 700,
                fontSize: token.fsCaption,
              }}
            >
              {i + 1}
            </span>
            <div>
              <strong style={{ display: "block", color: token.graphite }}>
                {t(`lis.trouble.${s}.title`)}
              </strong>
              <span style={{ color: token.slate, fontSize: token.fsBody, lineHeight: 1.6 }}>
                {t(`lis.trouble.${s}.desc`)}
              </span>
            </div>
          </li>
        ))}
      </ol>
      <Button variant="secondary" onClick={() => navigate("/lis/flux")}>
        {t("lis.trouble.goMonitor")}
      </Button>
    </div>
  );
}
